// extracted by mini-css-extract-plugin
export default {"overlay":"nw-z","bodyOpen":"ow-z","content":"pw-z","header":"qw-z","close":"rw-z","closeNoHeading":"sw-z"};